import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { Tours } from "./pages/Tours";
import { DomesticTours } from "./pages/DomesticTours";
import { InternationalTours } from "./pages/InternationalTours";
import { HoneymoonPackages } from "./pages/HoneymoonPackages";
import { GroupTours } from "./pages/GroupTours";
import { PilgrimTours } from "./pages/PilgrimTours";
import { Contact } from "./pages/Contact";
import { TourDetails } from "./pages/TourDetails";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/tours" element={<Tours />} />
            <Route path="/tours/domestic" element={<DomesticTours />} />
            <Route path="/tours/international" element={<InternationalTours />} />
            <Route path="/tours/honeymoon" element={<HoneymoonPackages />} />
            <Route path="/tours/group" element={<GroupTours />} />
            <Route path="/tours/pilgrim" element={<PilgrimTours />} />
            <Route path="/tour/:id" element={<TourDetails />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
